
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import creditServices from '@/services/credit-services';
import { eventBus } from '@/main';
const numeral = require('numeral');
@Component({
    components: {
        Loading
    }
})
export default class Recharge extends Vue {
  @Prop({ default: null })
  private onRecharge!: boolean;
  private bankInfo = {
      'name': '',
      'acc_number': '',
      'acc_name': ''
    }
  private bankInfos = [
    // {
    //   'name': 'MBbank',
    //   'acc_number': '0962589973',
    //   'acc_name': 'DINH BA KHUE'
    // },
    // {
    //     'name': 'MBV',
    //     'acc_number': '12336886',
    //     'acc_name': 'BUI THI HIEN'
    // },
    // {
    //     'name': 'VPBank',
    //     'acc_number': '8102686856',
    //     'acc_name': 'DO BUI NGOC BICH'
    // }
    {
        'name': 'MBV',
        'acc_number': '14881606',
        'acc_name': 'DINH THI DIU'
    },
    {
        'name': 'ACB',
        'acc_number': '50631457',
        'acc_name': 'DINH BA KHUE'
    }
  ]
  private isLoading = false;
  private rechargeModel = {
    rechargeValue: 0,
    bankId: 0,
    tradeContent: ''
  };
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  get rechargeMethods() {
    return DATA.rechargeMethods;
  }
  get qrLink() {
    return `https://api.vietqr.io/image/${this.bankInfo.name}-${this.bankInfo.acc_number}-K5pY8mL.jpg?addInfo=NHTD${this.userInfo.userId}&accountName=${this.bankInfo.acc_name}`;
  }
  @Watch('onRecharge', { immediate: true, deep: true })
  private watchOnRecharge() {
    this.recharge();
  }

  mounted() {
    this.shuffleArray(this.bankInfos);
    this.bankInfo = this.bankInfos[0];
  }

  private shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  private async recharge() {
    try {
      const isValid = await (this.$refs['observer'] as any).validate();
      if (isValid) {

        this.isLoading = true;

        const dataRequest = {
          Amount: numeral(this.rechargeModel.rechargeValue).value(),
          Method: this.rechargeModel.bankId,
          UID: this.userInfo.userId,
          Username: this.userInfo.userName,
          TradeContent: this.rechargeModel.tradeContent
        };

        const result = await creditServices.submitRecharge(dataRequest);

        if (
          result &&
          result.status === 200 &&
          result.data.message === 'Success'
        ) {
          Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thành công!',
          });
          this.rechargeModel = {
            rechargeValue: 0,
            bankId: 0,
            tradeContent: ''
          };
          eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
        } else {
          Vue.notify({
            group: 'foo',
            type: 'error',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thất bại!',
          });
        }
        this.isLoading = false;
      }
    } catch {
      return false;
    }
  }
}
